export default "__VITE_ASSET__D0OhCVH7__"